import React, { useEffect } from "react";
import { scrollToSection } from "../../utils/scrollToSection";
import "./hero.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";
// import { useNavigate } from "react-router-dom";
gsap.registerPlugin(ScrollTrigger);


const Hero = () => {

  useEffect(() => {

    // ===============================
    // ✨ SPLIT TEXT ANIMATION (ENTRY)
    // ===============================
    const title = new SplitType(".hero-title", { types: "chars" });
    const desc = new SplitType(".hero-desc", { types: "words" });

    gsap.from(title.chars, {
      opacity: 0,
      y: 60,
      rotateX: -80,
      stagger: 0.03,
      duration: 1,
      ease: "power3.out",
    });

    gsap.from(desc.words, {
      opacity: 0,
      y: 20,
      stagger: 0.05,
      delay: 0.5,
      duration: 0.8,
      ease: "power2.out",
    });

    // ===============================
    // 🚁 DRONE ZOOM IMAGE EFFECT
    // ===============================
    gsap.to(".hero-image", {
      scale: 1.3,
      y: 120,
      ease: "none",
      scrollTrigger: {
        trigger: ".home-hero",
        start: "top top",
        end: "bottom top",
        scrub: 1.2,
      },
    });

    // ===============================
    // 🌫 TEXT FLOAT OUT (DEPTH FEEL)
    // ===============================
    gsap.to(".hero-content", {
      y: -150,
      scale: 1.05,
      rotateX: 6,
      opacity: 0.2,
      ease: "none",
      scrollTrigger: {
        trigger: ".home-hero",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    // ===============================
    // 🌑 OVERLAY DARKEN SCROLL
    // ===============================
    gsap.to(".overlay", {
      opacity: 0.85,
      scrollTrigger: {
        trigger: ".home-hero",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

  }, []);
  // const navigate = useNavigate();
  return (

    <section className="home-hero" id="home">

      {/* BACKGROUND IMAGE */}
      <img
        src="/images/pristine210.png"
        alt="construction"
        className="hero-image"
      />

      {/* DARK OVERLAY */}
      <div className="overlay"></div>

      {/* HERO CONTENT */}
      <div className="hero-content">

        <h1 className="hero-title">
          A Landmark of Urban
        </h1>
        <h1 className="hero-title">
          Sophistication in Viman
        </h1>
        <h1 className="hero-title">
          Nagar, Pune
        </h1>

        <p className="hero-desc">
          Kyra offers strong potential for both lifestyle satisfaction and financial growth.
        </p>

        {/* <button onClick={() => navigate("/contact")}>
          Download Brochure
        </button> */}
        <button
  onClick={() =>
    document.getElementById("contact")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    })
  }
>
  Download Brochure
</button>

      </div>
      {/* MAHARERA NUMBER */}
      <div className="maharera-badge">
        MahaRERA No: P52100012345
      </div>
    </section>
  );
};

export default Hero;